<template>
  <header class="header">
    <div class="header_left"></div>
    <div class="header_right">
      <!-- 倒计时刷新接口 -->
      <auth-img
        :src="TimerRefreshDisbale"
        v-if="timerRefreshLimit?.countdown"
        class="reloadlimit"
        alt=""
      />
      <auth-img :src="TimerRefresh" @click="refreshTimerFetch" v-else class="reload" alt="" />
      <!-- 分割线 -->
      <a-divider type="vertical" class="divider" />
      <!-- 工作 -->
      <div class="work-status" style="cursor: pointer">
        <a-dropdown :trigger="['click']">
          <div class="status-content">
            <a-badge :status="shiftStatusMap[workStatus].status" />
            <div class="status-info">
              <span class="status-label">{{ shiftStatusMap[workStatus].label }}</span>
              <span class="status-timer" v-if="timerToAutoRest?.countdown && workStatus === 2">
                {{ timerToAutoRest.formatTime }}
              </span>
              <span class="status-timer" v-if="workStatus === 0">
                未接收{{
                  ~~shiftStatusConfig?.currentContinueUntreatedTimes +
                  '/' +
                  ~~shiftStatusConfig?.doctorAssistantContinueUntreatedTimes
                }}
              </span>
            </div>
            <DownOutlined />
          </div>
          <template #overlay>
            <a-menu @click="handleMenuClick">
              <a-menu-item v-for="it in shiftStatusMap" :key="it.value">
                <span>
                  <a-badge :status="it.status" />
                  {{ it.label }}
                </span>
                <a-menu-divider v-if="!it.hideDivider" />
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <!-- 用户头像 -->
      <div class="user-avatar">
        <a-dropdown :trigger="['click']">
          <div>
            <a-avatar :size="24" :src="avator" />
          </div>
          <template #overlay>
            <a-menu>
              <a-menu-item @click="LogOutConfirm">
                <span>退出登录</span>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <a-tooltip placement="bottomRight">
        <template #title>
          <span v-if="userName.length > 3">{{ userName }}</span>
        </template>
        <div class="user-name">{{ nameLimit(userName) }}</div>
      </a-tooltip>
    </div>
  </header>
  <!-- 状态切换弹窗 -->
  <a-modal
    :visible="modalObj.visible"
    @ok="handleOk"
    @cancel="handleCancel"
    :closable="false"
    :destroyOnClose="true"
  >
    <div class="modal_content">
      <div class="modal-title">
        <div style="display: flex">
          <ExclamationCircleOutlined
            class="icon"
            style="color: #faad14; margin-right: 16px; font-size: 22px"
          />
        </div>
        <div>{{ modalObj.title }}</div>
      </div>
      <div class="modal-content" v-if="modalObj.content">
        {{ modalObj.content }}
      </div>
      <div class="modal-textarea" v-if="modalObj.showInput">
        <a-textarea
          placeholder="请在此处补充修改理由~"
          v-model:value="modalObj.reason"
          show-count
          :maxlength="50"
          :auto-size="{ minRows: 3, maxRows: 5 }"
        />
      </div>
    </div>
  </a-modal>
</template>

<script>
import { computed, defineComponent, createVNode, watch, onMounted, reactive } from 'vue'
import { DownOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import { getToken, TokenKey } from '@/utils/auth'
import WebIM from '@/utils/WebIM'
import EventBus from '@/utils/EventBus.js'
import { Modal, message } from 'ant-design-vue'
import Cookies from 'js-cookie'
import { shiftStatusMap } from '@/utils/globalMap'
import { REFRESH_LIST } from '@/views/WorkPlace/handleEventBuss'

import { clearStoreChatMsgList } from '@/utils/unReadNum'
import TimerRefresh from '@/assets/img/timerRefresh.png'
import TimerRefreshDisbale from '@/assets/img/timerRefreshDisable.png'
import { getDiffSeconds } from '@/utils/index'
import { stutas as TcccStutas } from '@/utils/Tccc'
import { getRestCount } from '@/api/login'
export default defineComponent({
  components: {
    DownOutlined,
    ExclamationCircleOutlined
  },
  setup() {
    const modalObj = reactive({
      visible: false,
      title: '', // 弹窗标题
      content: '', // 弹窗内容
      reason: '', // 输入框的值
      status: null, // 切换状态
      showInput: false // 是否显示input输入框
    })
    const avator = require('@/assets/img/default_avator.png')
    const store = useStore()
    const workStatus = computed(() => store.getters.workStatus || 0)
    const userName = computed(() => store.getters.userInfo.realName)
    const pendingCount = computed(() => store.state.workOrder.pendingCount)
    const processingCount = computed(() => store.state.workOrder.processingCount)
    const dealingActiveTab = computed(() => store.state.workOrder.activeKey)

    const timerCollection = computed(() => store.state.rollBack.roundInstance)
    const timerToAutoRest = computed(() => timerCollection.value.get('AUTO_REST'))
    const timerRefreshLimit = computed(() => timerCollection.value.get('REFRESH_LIMIT'))
    const shiftStatusConfig = computed(() => store.state.user.shiftStatusConfig)
    watch([() => TcccStutas.value, () => workStatus.value], async () => {
      console.log('tccc-status', TcccStutas.value)
      console.log('tccc-workStatus', workStatus.value)
      // if (TcccStutas.value !== 'ready') return
      // 0 - 坐班中(接收)
      // 1 - 休息中
      // 2 - 坐班中(拒收)
      if ([0, 2].includes(workStatus.value)) {
        await window?.tccc?.Agent?.online()
        await window?.tccc?.Agent.setStatus({
          status: 'free'
        })
        // window?.tccc?.Agent.setStatus({
        //   status: 'free'
        // })
        // .then(() => {
        //   window?.tccc?.Agent?.online()
        // })
        console.log('tccc-上线了')
      } else {
        window?.tccc?.Agent?.offline()
        console.log('tccc-下线了')
      }
    })
    // 监控刷新倒计时
    watch(
      () => workStatus.value,
      val => {
        // 0 - 坐班中(接收)
        // 1 - 休息中
        // 2 - 坐班中(拒收)
        if (val === 0) {
          store.dispatch('user/queryShiftStaus')
          store.commit('rollBack/SET_ROUND_INSTANCE', {
            timer: 'AUTO_REST',
            callBackTime: null
          })
        }
        if (val === 1) {
          store.commit('rollBack/SET_ROUND_INSTANCE', {
            timer: 'AUTO_REST',
            callBackTime: null
          })
        }
        if (val === 2) {
          store.commit('rollBack/SET_ROUND_INSTANCE', {
            timer: 'AUTO_REST',
            callBackTime: shiftStatusConfig.value.currentAutoRestTime
          })
        }
      },
      { immediate: true }
    )
    // 考虑用户切换页签情况
    let levelTime = null
    onMounted(() => {
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
          console.log('离开了' + getDiffSeconds(levelTime) + 's')
          // 如果离开页面超过10分钟，则刷新
          if (getDiffSeconds(levelTime) > 600) {
            store.dispatch('rollBack/getAllRefreshTimer')
            store.dispatch('user/queryShiftStaus')
          }
        } else {
          levelTime = new Date().getTime()
        }
      })
    })

    const refreshTimerFetch = () => {
      store.commit('rollBack/SET_ROUND_INSTANCE', {
        timer: 'REFRESH_LIMIT',
        callBackTime: 300
      })
      store.dispatch('rollBack/getAllRefreshTimer')
      store.dispatch('user/queryShiftStaus')
    }
    // 弹窗关闭
    const handleCancel = () => {
      modalObj.visible = false
      modalObj.title = ''
      modalObj.content = ''
      modalObj.reason = ''
      modalObj.status = null
      modalObj.showInput = false
    }
    const handleOk = () => {
      if (modalObj.showInput && !modalObj.reason) {
        message.warning('请输入修改理由')
        return
      }
      // 这里会发起请求
      // modalObj.reason
      store
        .dispatch('user/handleChangeWorkStatus', {
          status: modalObj.status,
          reason: modalObj.status === 1 ? modalObj?.reason || undefined : undefined
        })
        .then(async () => {
          // 0-坐班中
          await store.dispatch('user/queryShiftStaus')
          REFRESH_LIST?.emit()
          // 0 - 坐班中(接收)
          // 1 - 休息中
          // 2 - 坐班中(拒收)
          if (modalObj.status === 1) {
            // 只有切换到休息中时候需要将正在处理的群组信息删除
            store.commit('workOrder/SET_GROUP_INFO')
            store.commit('workOrder/SET_ISGUIDE_CONSULT')
            store.commit('workOrder/SET_CHART_ID')
            // 初始化群组信息
            store.commit('initChatState')
            clearStoreChatMsgList()
          }
          if (modalObj.status === 2) {
            store.commit('rollBack/SET_ROUND_INSTANCE', {
              timer: 'AUTO_REST',
              callBackTime: shiftStatusConfig.value.currentAutoRestTime
            })
          }
        })
      handleCancel()
    }
    // 切换坐班状态
    const handleMenuClick = ({ key }) => {
      if (key === workStatus.value) return
      modalObj.visible = true
      modalObj.status = key
      modalObj.content = ''
      // 根据不同状态设置标题和内容
      const statusLabel = shiftStatusMap[key].label
      if (key === 1) {
        // 休息中状态特殊处理
        modalObj.title = `确定切换为${statusLabel}`
        // 获取修改休息的次数
        getRestCount().then(res => {
          const count = res + 1
          const commonMsg = '该状态将无法接收新工单，且待处理重新分配、处理中的工单回滚工单池。'
          modalObj.content = `这是您今天第${count}次修改为${statusLabel}，${commonMsg}`
          modalObj.showInput = count >= 3
        })
      } else {
        // 其他状态
        modalObj.title = `确定切换为${statusLabel}状态`
      }
      // Modal.confirm({
      //   title: `确定切换为${shiftStatusMap[key].label}状态`,
      //   icon: createVNode(ExclamationCircleOutlined),
      //   content: text,
      //   onOk: () => {
      //     // 这里会发起请求
      //     store.dispatch('user/handleChangeWorkStatus', key).then(async () => {
      //       // 0-坐班中
      //       await store.dispatch('user/queryShiftStaus')
      //       REFRESH_LIST?.emit()
      //       // 0 - 坐班中(接收)
      //       // 1 - 休息中
      //       // 2 - 坐班中(拒收)
      //       if (key === 1) {
      //         // 只有切换到休息中时候需要将正在处理的群组信息删除
      //         store.commit('workOrder/SET_GROUP_INFO')
      //         store.commit('workOrder/SET_ISGUIDE_CONSULT')
      //         store.commit('workOrder/SET_CHART_ID')
      //         // 初始化群组信息
      //         store.commit('initChatState')
      //         clearStoreChatMsgList()
      //       }

      //       if (key === 2) {
      //         store.commit('rollBack/SET_ROUND_INSTANCE', {
      //           timer: 'AUTO_REST',
      //           callBackTime: shiftStatusConfig.value.currentAutoRestTime
      //         })
      //       }
      //     })
      //   }
      // })
    }
    // 退出
    const LogOutConfirm = () => {
      const text = pendingCount.value
        ? '退出后，坐班状态会自动切换成休息状态，待处理的工单将随机分配给坐班中（接收）状态的账号'
        : '退出后，坐班状态会自动切换成休息状态'
      Modal.confirm({
        title: '确定退出当前账号？',
        icon: createVNode(ExclamationCircleOutlined),
        content: text,
        onOk: () => {
          outLogin()
        }
      })
    }
    const outLogin = async () => {
      const query = {
        accountType: 4,
        [TokenKey]: getToken()
      }
      store.dispatch('user/logOut', query).then(() => {
        //环信退出
        WebIM.conn.close()
        //监听事件清除
        EventBus.all.clear()
        // 这里暂时使用跳转，因为跳转丢失所有store数据
        Cookies.remove('version')
        // 清空缓存病历内容
        sessionStorage.setItem(`SESSION_MEDICAL_RECORD`, '{}')
        clearStoreChatMsgList()
        location.href = '/login'
        // 移除所有定时器逻辑
        store.commit('rollBack/CLEAR_ALLTIMER_ROUND')
      })
    }
    const nameLimit = name => {
      if (name.length > 3) {
        return name.substring(0, 3) + '...'
      }
      return name
    }
    return {
      avator,
      workStatus,
      userName,
      handleMenuClick,
      outLogin,
      nameLimit,
      LogOutConfirm,
      shiftStatusMap,
      timerToAutoRest,
      TimerRefresh,
      TimerRefreshDisbale,
      timerRefreshLimit,
      refreshTimerFetch,
      shiftStatusConfig,
      modalObj,
      handleCancel,
      handleOk
    }
  }
})
</script>

<style lang="scss" scoped>
.modal_content {
  .modal-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    font-size: 16px;
    display: flex;
    align-items: center;
  }
  .modal-content {
    margin-top: 8px;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    margin-left: 38px;
  }
  .modal-textarea {
    margin-left: 38px;
    margin-top: 8px;
  }
}
.header {
  display: flex;
  justify-content: space-between;
  background: #001529;
  color: white;
  font-family: PingFangSC-Medium;

  &_right {
    display: flex;
    align-items: center;

    .reload {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }

    .reloadlimit {
      width: 20px;
      height: 20px;
      cursor: not-allowed;
    }

    .divider {
      border-left: 1px solid rgb(255, 255, 255, 0.5);
      height: 16px;
      margin: 2px 16px 0;
    }

    .work-status,
    .user-avatar {
      margin-right: 8px;
      cursor: pointer;
    }

    .status-content {
      display: flex;
      align-items: center;
    }

    .status-info {
      display: flex;
      flex-direction: column;
      line-height: normal;
      margin-right: 10px;

      .status-label {
        font-size: 14px;
      }

      .status-timer {
        font-size: 12px;
      }
    }

    .user-name {
      margin-right: 32px;
      font-weight: 500;
      font-size: 14px;
    }

    ::v-deep(.ant-badge-status-dot) {
      width: 11px;
      height: 11px;
    }
  }
}
</style>
